import React, { FC } from "react";
import { faToggleOff, faToggleOn } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type PublicGallerySwitchProps = {
  isPublic: boolean;
  onAnimationPublicToggled: (isPublic: boolean) => void;
};

const PublicGallerySwitch: FC<PublicGallerySwitchProps> = (props) => {
  return (
    <div
      className={`public-switch inline-block public-switch--${props.isPublic ? "public" : "private"
        }`}
      onClick={() => {
        props.onAnimationPublicToggled(!props.isPublic);
      }}
    >
      <span className="public-switch__label--private">Private</span>
      <FontAwesomeIcon icon={props.isPublic ? faToggleOn : faToggleOff} />
      <span className="public-switch__label--public">In Gallery</span>
    </div>
  );
};

export default PublicGallerySwitch;
